export default {
  'form.fields.first_name': 'FIRST NAME(S)',
  'form.fields.last_name': 'Family NAME',
  'form.fields.email': 'E-MAIL',
  'form.fields.gender': 'GENDER',
  'form.fields.nationality': 'CITIZENSHIP',
  'form.fields.ogranisation': 'INSTITUTION',
  'form.fields.position': 'POSITION',

  'ui.signup': 'Sign up',
  'ui.gdpr': 'General Data Protection Regulation',
  'ui.agb': 'terms and conditions',

  'ui.thankyou': 'Thank you for your registration!',
  'ui.thankyou.message': 'A confirmation will be sent to your e-mail address soon.',

  'signupform.checkbox.gdpr': 'I understand that my personal data will be processed and stored for the purposes of the event in accordance with the {link} of the European Union.',
  'signupform.checkbox.newsletter': 'Please send me the ACP News and relevant information about future ACP events. I understand that my personal data will be processed and stored in accordance with the General Data Protection Regulation of the European Union and that I may revoke my consent any time.',
  'signupform.checkbox.agb': 'I have read and accept the {link}.'
}
